import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
function Stars() {
  return <div className="flex gap-1 mb-3" data-id="element-351">
      {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-gold-500 text-gold-500" data-id="element-352" />)}
    </div>;
}
export function Testimonials() {
  return <section className="py-20 px-4 bg-dark-900 border-t border-gold-500/10" data-id="element-353">
      <div className="max-w-5xl mx-auto" data-id="element-354">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-3xl md:text-4xl font-serif text-gold-500 mb-12 text-center" data-id="element-355">
          Lo que dicen quienes ya se blindaron
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12" data-id="element-356">
          {/* Testimonio 1 — Carlos M. */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="bg-dark-800 border border-gold-500/15 rounded-2xl p-6 flex flex-col" data-id="element-357">
            <div className="flex items-center gap-4 mb-4" data-id="element-358">
              <img src="https://cdn.magicpatterns.com/uploads/wN9xkxXPPtDSuqANc8GqnT/Testimonio_Carlos_M..png" alt="Carlos M." className="w-14 h-14 rounded-full object-cover border-2 border-gold-500/30" data-id="element-359" />
              <div data-id="element-360">
                <p className="text-white font-semibold" data-id="element-361">Carlos M.</p>
                <Stars data-id="element-362" />
              </div>
            </div>
            <p className="text-gray-300 italic leading-relaxed" data-id="element-363">
              "No necesitaba otro curso de IA. Necesitaba dejar de sentirme
              reemplazable. El Anti-Manual me ayudó a entender dónde estaba
              perdiendo valor y cómo volverme más difícil de sustituir."
            </p>
          </motion.div>

          {/* Testimonio 2 — Valentina R. */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="bg-dark-800 border border-gold-500/15 rounded-2xl p-6 flex flex-col" data-id="element-364">
            <div className="flex items-center gap-4 mb-4" data-id="element-365">
              <img src="https://cdn.magicpatterns.com/uploads/2opV7se8kXfx9riSFkF9MA/Testimonio_Valentina_R..png" alt="Valentina R." className="w-14 h-14 rounded-full object-cover border-2 border-gold-500/30" data-id="element-366" />
              <div data-id="element-367">
                <p className="text-white font-semibold" data-id="element-368">Valentina R.</p>
                <Stars data-id="element-369" />
              </div>
            </div>
            <p className="text-gray-300 italic leading-relaxed" data-id="element-370">
              "Lo compré por miedo a quedarme atrás. Lo terminé sintiendo como
              una ventaja estratégica. Si trabajas con tu mente y sientes que el
              mercado cambió, esto te ordena y te despierta."
            </p>
          </motion.div>
        </div>

        {/* Testimonio 3 — Video — Marcos G. */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="max-w-md mx-auto" data-id="element-371">
          <div className="bg-dark-800 border border-gold-500/15 rounded-2xl p-6" data-id="element-372">
            <div className="flex items-center gap-4 mb-4" data-id="element-373">
              <div className="w-14 h-14 rounded-full bg-dark-700 border-2 border-gold-500/30 flex items-center justify-center text-gold-500 font-serif text-xl font-bold" data-id="element-374">
                M
              </div>
              <div data-id="element-375">
                <p className="text-white font-semibold" data-id="element-376">Marcos G.</p>
                <Stars data-id="element-377" />
              </div>
            </div>
            <div className="relative w-full rounded-xl overflow-hidden" style={{
            aspectRatio: '9/16',
            maxHeight: '480px'
          }} data-id="element-378">
              <iframe src="https://www.youtube.com/embed/7DuUG-hUBEM" title="Testimonio de Marcos G." allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen className="absolute inset-0 w-full h-full" data-id="element-379" />
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}